export default __webpack_public_path__ + "static/media/logo-dark.2e223add.png";